import React, { useState } from 'react';
import helpers from '../helpers';
import MaskedInput from 'react-text-mask';
import useTheme from '../hooks/useTheme';


function Login({ handleConfirm, handleModal, handleUrl, handleCredit, handleCreditTemplate, handleLocution, handleModalErro, handleModalVideoUnavailable, setShowLoader }) {
    const [cpfClassName, setCpfClassName] = useState("");
    const [dataNascimentoClassName, setDataNascimentoClassName] = useState("");
    const [cpfVal, setCpfVal] = useState("");
    const [dtNascVal, setDtNascVal] = useState("");
    const { getThemeClass } = useTheme();

    return (
        <div id="boxIdentificacao" className="bundleTela">
            <div className={getThemeClass('boxLogin')} style={{ "marginTop": "150px" }}>
                <label className="bundleTitulo bundleCentro"> Identifique-se </label>
                <label className="bundleDescricao">
                    Preencha seus dados para assistir ao vídeo exclusivo <br />com as principais informações da sua apólice.
                </label>
                <div className="bundleSessao">
                    <label className="bundleLabel">CPF</label>
                    <MaskedInput type="text"
                        className={cpfClassName}
                        id="cpfInput"
                        name="cpf"
                        placeholder="000.000.000-00"
                        mask={[/[0-9]/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                        value={cpfVal}
                        onChange={(e) => setCpfVal(helpers.validateCpf(e.target.value, setCpfClassName))}
                        required />
                    <div id="cpfError" className={cpfClassName === "error" ? "bundleAlerta" : "hidden"} >CPF inválido!</div>
                </div>
                <div className="bundleSessao">
                    <label className="bundleLabel">Data de Nascimento</label>
                    <MaskedInput type="text"
                        className={dataNascimentoClassName}
                        name="dataNascimento"
                        id="dataNascimentoInput"
                        placeholder="DD/MM/AAAA"
                        mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                        value={dtNascVal}
                        onChange={(e) => setDtNascVal(helpers.validateDataNascimento(e.target.value, setDataNascimentoClassName))}
                        required />
                    <div id="dataNascimentoError" className={dataNascimentoClassName === "error" ? "bundleAlerta" : "hidden"} >Data de nascimento inválida!</div>
                </div>
                <div className="bundleSessao">
                    <label className="bundleMensagem">
                        Assim que clicar em continuar, aguarde alguns segundos enquanto carregamos o seu vídeo. Fizemos pensando em você e na proteção que escolheu. Esperamos que goste.
                    </label>
                </div>
                <div className="bundleSessao">
                    <a href="#" id="linkModal" className="bundleLabelLink" onClick={(e) => { e.preventDefault(); handleModal(true); }}>Seus dados não foram reconhecidos?</a>
                    <button id="btnConfirmar"
                         className={getThemeClass('button')}
                        onClick={(e) => { e.preventDefault(); helpers.doLogin(cpfVal, dtNascVal, handleConfirm, handleUrl, handleCredit, handleCreditTemplate, handleLocution, handleModalErro, handleModalVideoUnavailable, setShowLoader) }}
                        disabled={cpfClassName === "error" || dataNascimentoClassName === "error" || cpfVal === "" || dtNascVal === ""}>
                        Continuar
                    </button>
                </div>
            </div>
        </div >
    );
}

export default Login;